module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 5
// module chunks = 0 1 2 3